import getJSONValueWithPseudoState from '../fields/getJSONValueWithPseudoState';
export default function getStyleObjectWithPseudoState(styleObject, customStyleSettings, pseudoState) {
    const styleObjectWithPseudoState = getJSONValueWithPseudoState(pseudoState)(Object.assign(Object.assign({}, styleObject), (customStyleSettings ? {
        customSettings: customStyleSettings
    } : undefined)));
    return {
        styleObject: styleObjectWithPseudoState[pseudoState],
        customStyleSettings: styleObjectWithPseudoState.customSettings ? styleObjectWithPseudoState.customSettings[pseudoState] : undefined
    };
}
